import { NgModule } from '@angular/core';
import { BrIconComponent } from './ui/icon/icon.component';
import { BrIconRegistry } from './ui/icon/icon-registry.service';
import { DomSanitizer } from '@angular/platform-browser';

/** Shared SVG artwork for Workspace controls and file navigation. */
@NgModule({
  imports: [BrIconComponent],
  exports: [BrIconComponent],
})
export class WorkspaceIconsModule {
  constructor(registry: BrIconRegistry, sanitizer: DomSanitizer) {
    // These SVG literals are trusted static artwork, never user-supplied markup.
    registry.addSvgIconLiteralInNamespace('br', 'compose', sanitizer.bypassSecurityTrustHtml(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M11 4H7a4 4 0 0 0-4 4v9a4 4 0 0 0 4 4h9a4 4 0 0 0 4-4v-4"/>
        <path d="m16.5 3.5-8 8L7 17l5.5-1.5 8-8a2.83 2.83 0 0 0-4-4Z"/>
        <path d="m15 5 4 4"/>
      </svg>
    `));
    registry.addSvgIconLiteralInNamespace('br', 'window', sanitizer.bypassSecurityTrustHtml(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="2" y="4" width="20" height="16" rx="2"/>
        <rect x="5" y="7" width="14" height="10" rx="1"/>
        <path d="M5 10h14" stroke-width="1.25"/>
      </svg>
    `));
    registry.addSvgIconLiteralInNamespace('br', 'maximize', sanitizer.bypassSecurityTrustHtml(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="2" y="4" width="20" height="16" rx="2"/>
        <path d="M5 7l4 3M5 10V7h3M19 7l-4 3M16 7h3v3M5 17l4-3M5 14v3h3M19 17l-4-3M16 17h3v-3" stroke-width="1.25"/>
      </svg>
    `));
    registry.addSvgIconLiteralInNamespace('br', 'dock-right', sanitizer.bypassSecurityTrustHtml(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="2" y="4" width="20" height="16" rx="2"/>
        <path d="M15 4v16"/>
        <path d="M17 9h3m-3 3h3m-3 3h3" stroke-width="1.25"/>
      </svg>
    `));
    // Font Awesome Free 6.7.2 solid folders; the open glyph is normalized from 576 to 512 units wide.
    // Both use the same canvas and visible bounds, so opening a folder does not change its size.
    registry.addSvgIconLiteralInNamespace('br', 'folder', sanitizer.bypassSecurityTrustHtml(`
      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2024 Fonticons, Inc. --><path d="M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"/></svg>
    `));
    registry.addSvgIconLiteralInNamespace('br', 'folder-open', sanitizer.bypassSecurityTrustHtml(`
      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2024 Fonticons, Inc. --><path transform="scale(0.8888888889 1)" d="M88.7 223.8L0 375.8 0 96C0 60.7 28.7 32 64 32l117.5 0c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7L416 96c35.3 0 64 28.7 64 64l0 32-336 0c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1C122.1 230 132.6 224 144 224l400 0c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480L32 480c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2 .1-32.1l112-192z"/></svg>
    `));
  }
}
